module.exports = __webpack_public_path__ + "static/media/BannerCongresoEN.847a5e35.jpg";